"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _useAPICallRepetitionFromError = require("../../../hooks/error/useAPICallRepetitionFromError");
var _questionnaireActions = require("../../../store/questionnaire/questionnaireActions");
var _EntelDynamicMessageTemplate = _interopRequireDefault(require("../../EntelDynamicMessageTemplate/EntelDynamicMessageTemplate"));
var _useAppDispatch = require("../../../hooks/useAppDispatch");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const EntelErrorBody = () => {
  const {
    errorMessage,
    retryAPICall,
    callIsInProgress
  } = (0, _useAPICallRepetitionFromError.useAPICallRepetitionFromError)();
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const onRestart = () => {
    dispatch((0, _questionnaireActions.resetQuestionnaire)());
    dispatch((0, _questionnaireActions.resetQuestionnaireOnError)());
  };
  return /*#__PURE__*/_react.default.createElement(_EntelDynamicMessageTemplate.default, {
    imagePath: "assets/ws10/icons/entel/tasksMan.png",
    translationKeys: {
      heading: 'ErrorPage.Heading',
      message: errorMessage,
      titleTestId: 'error-title',
      subtitleTestId: 'error-subtitle'
    },
    containerTestId: "error-screen-body",
    buttons: {
      primary: {
        onClick: retryAPICall,
        state: callIsInProgress ? 'disabled' : '',
        translationKey: 'ErrorPage.Button',
        buttonTestId: 'error-try-again-btn'
      },
      secondary: {
        onClick: onRestart,
        state: callIsInProgress ? 'disabled' : '',
        translationKey: 'ErrorPage.RetryButton',
        buttonTestId: 'error-back-btn'
      }
    }
  });
};
var _default = EntelErrorBody;
exports.default = _default;